import script from "./port-type-distribution-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./port-type-distribution-chart.vue?vue&type=script&lang=ts&setup=true"

import "./port-type-distribution-chart.vue?vue&type=style&index=0&id=1fc8d39a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc8d39a"]])

export default __exports__